// extracted by mini-css-extract-plugin
module.exports = {"bottomSection":"bottomSection_bottomSection__hT_Kz","copyright":"bottomSection_copyright__qjHvf","logos":"bottomSection_logos__i1AA7"};